import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'white' | 'tint' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  white: 'bg-white text-slate-900',
  tint: 'bg-blue-50 text-slate-900',
  deep: 'bg-blue-900 text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-222" data-mp="2q53qnwnveoq">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-4xl' : 'max-w-5xl'}`} data-id="element-223" data-mp="7oyg2d07oznb">
        {hasHeader && <header className="mx-auto max-w-4xl text-center" data-id="element-224" data-mp="vcy7zg99ew3h">
            {eyebrow && <p className={`mb-4 text-xs font-extrabold uppercase tracking-widest ${tone === 'deep' ? 'text-blue-200' : 'text-blue-600'}`} data-id="element-225" data-mp="1060yffiqppfg">
                {eyebrow}
              </p>}
            {title && <h2 className="text-3xl font-extrabold leading-tight tracking-tight md:text-5xl" data-id="element-226" data-mp="38dp0nf4yy9o4">
                {title}
              </h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${tone === 'deep' ? 'text-blue-100' : 'text-blue-900/70'}`} data-id="element-227" data-mp="3iajuhkqarlw2">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-228" data-mp="3nafpwvkxi500">{children}</div>
      </div>
    </section>;
}